import CollectionPayload from '@libraries/api/roles';
import CollectionPayloadApp from '@libraries/api/application';
import CollectionPayloadMenu from '@libraries/api/menu';
import FetchData from '@utils/fetch-data';
import { notification } from 'antd';
import { history, IFetchData, initialList } from 'asumsi-components';
import { Dispatch, SetStateAction, useState } from 'react';
import { IResponseRoles } from '@interfaces/iresponse-role';
import { IResponseApplication } from '@interfaces/iresponse-application';
import { IResponseMenu } from '@interfaces/iresponse-menu';

const initialData = initialList.data;
const initialMeta = initialList.meta;
const defaultPage: number = 1;

export default function useAction() {
    const [isLoader, setIsLoader]: [boolean, Dispatch<SetStateAction<boolean>>] = useState(false);
    const [data, setData]: [
        IResponseRoles[],
        Dispatch<SetStateAction<IResponseRoles[]>>,
    ] = useState(initialData);

    const [applications, setDataApp]: [
        IResponseApplication[],
        Dispatch<SetStateAction<IResponseApplication[]>>,
    ] = useState(initialData);

    const [menus, setDataMenu]: [
        IResponseMenu[],
        Dispatch<SetStateAction<IResponseMenu[]>>,
    ] = useState(initialData);

    const [metaData, setMeta]: [
        any,
        Dispatch<SetStateAction<any>>,
    ] = useState(initialMeta);

    const [detail, setDetail]: [
        any,
        Dispatch<SetStateAction<any>>,
    ] = useState();

    const getData = async (params: any) => {
        const payload: IFetchData = CollectionPayload.read(params);

        setIsLoader(true);

        try {
            const response: any = await FetchData({ ...payload });
            setData(response.data.data);
            setMeta(response.data.meta);
            setIsLoader(false);
        } catch (error) {
            const { response } = error;
            setData(initialData);
            setMeta(initialMeta);
            setIsLoader(false);
            notification.error({
                description: response ? response.data.message : "gagal mengambil data",
                duration: 5,
                message: 'Failed',
            });
        }
    };

    const getApplications = async (params: any) => {
        const payload: IFetchData = CollectionPayloadApp.read(params);

        setIsLoader(true);

        try {
            const response: any = await FetchData({ ...payload });
            setDataApp(response.data.data);
            setIsLoader(false);
        } catch (error) {
            const { response } = error;
            setDataApp(initialData);
            setIsLoader(false);
            notification.error({
                description: response ? response.data.message : "gagal mengambil data",
                duration: 5,
                message: 'Failed',
            });
        }
    };

    const getMenus = async (params: any) => {
        const payload: IFetchData = CollectionPayloadMenu.read(params);

        setIsLoader(true);

        try {
            const response: any = await FetchData({ ...payload });
            setDataMenu(response.data.data);
            setIsLoader(false);
        } catch (error) {
            const { response } = error;
            setDataMenu(initialData);
            setIsLoader(false);
            notification.error({
                description: response ? response.data.message : "gagal mengambil data",
                duration: 5,
                message: 'Failed',
            });
        }
    };

    const getDetail = async (id: string) => {
        const payload: IFetchData = CollectionPayload.readOne(id);

        setIsLoader(true);

        try {
            const response: any = await FetchData({ ...payload });
            setIsLoader(false);
            setDetail(response.data.data);
        } catch (error) {
            const { response } = error;
            setIsLoader(false);
            notification.error({
                description: response ? response.data.message : "gagal mengambil data",
                duration: 5,
                message: 'Failed',
            });
        }
    };



    const postData = async (params: any) => {
        const payload: IFetchData = CollectionPayload.post(params);

        setIsLoader(true);

        try {
            await FetchData({ ...payload });
            setIsLoader(false);
            notification.success({
                message: 'Berhasil',
                duration: 5,
                description: 'Berhasil simpan data',
            });
            history.push({
                pathname: '/user/roles',
            });
        } catch (error) {
            const { response } = error;
            setIsLoader(false);
            notification.error({
                description: response ? response.data.message : "gagal menyimpan data",
                duration: 5,
                message: 'Failed',
            });
        }
    };

    const updateData = async (params: any, id: string) => {
        const payload: IFetchData = CollectionPayload.put(params, id);

        setIsLoader(true);

        try {
            await FetchData({ ...payload });
            setIsLoader(false);
            notification.success({
                message: 'Berhasil',
                duration: 5,
                description: 'Berhasil simpan data',
            });
            history.push({
                pathname: '/user/roles',
            });
        } catch (error) {
            const { response } = error;
            setIsLoader(false);
            notification.error({
                description: response ? response.data.message : "gagal menyimpan data",
                duration: 5,
                message: 'Failed',
            });
        }
    };

    const deleteData = async (id: string) => {
        const payload: IFetchData = CollectionPayload.delete(id);
        setIsLoader(true);

        try {
            await FetchData({ ...payload });
            setIsLoader(false);
            notification.success({
                message: 'Success',
                duration: 5,
                description: "berhasil hapus data",
            });
        } catch (error) {
            setIsLoader(false);
            notification.error({
                description: "gagal hapus data",
                duration: 5,
                message: 'Failed',
            });
        }
    };

    return {
        data,
        defaultPage,
        getData,
        isLoader,
        setIsLoader,
        postData,
        metaData,
        getDetail,
        updateData,
        deleteData,
        getApplications,
        applications,
        detail,
        getMenus,
        menus
    };
}



// WEBPACK FOOTER //
// ./src/pages/roles/hooks/useAction.tsx